import sharedAnalyticsIntegrations from "../shared-components/analytics-integrations/analytics-utils";

declare const analytics: {
  track: (event: string, properties: Record<string, unknown>) => void;
};

type ButtonClickedProperties = {
  /** Where the button lives, e.g. "host hub". */
  buttonLocation: string;
  /** Lowercased button copy, e.g. "start increasing booking revenue". */
  buttonName: string;
  /** Listing use type, when the button relates to one. */
  useType?: string;
};

const track = (event: string, properties: Record<string, unknown>) => {
  if (!sharedAnalyticsIntegrations.segmentLoaded()) return;
  analytics.track(event, properties);
};

/**
 * Tracks the app-wide `button clicked` Segment event. Mirrors
 * web-listings-v2's `analyticsIntegrations.buttonClicked`.
 */
const trackButtonClicked = ({
  buttonLocation,
  buttonName,
  useType,
}: ButtonClickedProperties) => {
  track("button clicked", {
    button_name: buttonName,
    button_location: buttonLocation,
    ...(useType ? { use_type: useType } : {}),
  });
};

export { trackButtonClicked };
